<template>
  <section class="add-quote-container">
    <section v-if="type === 1">
      <h2>{{ isEdit? 'Edit': 'Add'}} Quote</h2>
      <div class="abs-top-right">
        <v-button @click="handlerCancel">Cancel</v-button>
        <v-button
          type="primary"
          @click="handlerSaveQuote">Save Quote</v-button>
      </div>
      <div class="form-container">
        <div class="flex-sb">
          <div class="form-item form-half">
            <span>Insurer</span>
            <!--            <v-select-->
            <!--              v-model="formData.company_id"-->
            <!--              :list="globalOptions.manual_quote_company" />           -->
            <v-select
              v-model="formData.company_id"
              :list="manualList" />
          </div>
          <div class="form-item form-half">
            <span>Quote ID</span>
            <v-input v-model="formData.quotation_number" />
          </div>
        </div>
        <h3>Files</h3>
        <file-container
          v-for="(item, index) in formData.files"
          :key="index"
          :fileData="item"
          :otherData="{
            index
          }"
          :edit="true"
          titleName= "Files"
          @delete="handlerDeleteFile"
          @uploadSuccess="handlerUploadSuccess"
        />
        <v-upload
          label="Click to upload"
          @uploadSuccess="handlerUploadSuccess" />
      </div>
    </section>
    <section v-else>
      <h2>{{ isEdit? 'Edit': 'Add'}} Policy</h2>
      <div class="abs-top-right">
        <v-button @click="() => $emit('cancel')">Cancel</v-button>
        <v-button
          type="primary"
          @click="handlerGetPremium">{{ isEdit? 'Save': 'Create'}} Policy</v-button>
      </div>
      <div class="form-container">
        <div class="form-item form-half">
          <span>Insurance Type</span>
          <v-select
            v-model="formData.insurance_type"
            :list="typeOptions"  />
        </div>

        <div
          v-if="formData.insurance_type == 1500"
          class="form-item form-half">
          <span>Type of Insurance</span>
          <v-radio-group
            v-model="motorsType"
            :button="true"
            :list="ticketOptions.motorsTypeOptions" />
        </div>

        <div
          v-if="formData.insurance_type == 1200"
          class="form-item form-half">
          <span>Type of Insurance</span>
          <v-select
            v-model="benefitsType"
            :list="ticketOptions.benefitsTypeOptions" />
        </div>

        <div class="flex-sb">
          <div class="form-item form-half">
            <span>Insurer</span>
            <v-select
              v-model="formData.company_id"
              :list="manualList" />
          </div>

        </div>
        <div class="form-item form-half">
          <span>Policy Number</span>
          <v-input v-model="formData.pcy_no" />
        </div>
        <div class="flex-sb">
          <!-- <div class="form-item form-half">
            <span>Effective Date</span>
            <v-date-picker
              v-model="formData.eff_date" />
          </div> -->
          <div class="form-item form-half">
            <span>Policy Period</span>
            <v-date-picker
              v-model="formData.date"
              type="daterange" />
          </div>
        </div>

        <span class="label">Insured Information</span>
        <div class="form-item form-half">
          <span>Insured Name</span>
          <v-input v-model="formData.isrd_nm" />
        </div>

        <span class="label">Contact Person</span>
        <div class="form-item form-half">
          <span>Name</span>
          <v-input v-model="formData.contact_nm" />
        </div>
        <div class="form-item form-half">
          <span>Phone No. </span>
          <v-input
            v-model="formData.contact_phone"
            type="number"/>
        </div>
        <div class="form-item form-half">
          <span>Email</span>
          <v-input v-model="formData.email" />
        </div>


        <div class="flex-sb">
          <div class="form-item form-half">
            <span>Remarks</span>
            <v-input
              v-model="formData.remark"
              type="textarea"
              :rows="4" />
          </div>
        </div>

        <business-premium-form
          ref="premium"
          :customerId="quoteOrderId? policyDetail.customer_id: customerId"
          :form="quoteOrderId? policyDetail.premium_data: relation"
          :quoteId="quoteOrderId? policyDetail.manual_id :quoteId"
          :orderId="quoteOrderId? quoteOrderId:orderId"
          :isEdit="isEdit"
          @submitPremium="submitPremium"
          @getSubmitPremium="getSubmitPremium"
        ></business-premium-form>
        <!-- <h3>Files</h3>
        <file-container
          v-for="(item, index) in formData.files"
          :key="index"
          :fileData="item"
          :otherData="{
            index
          }"
          :edit="true"
          @delete="handlerDeleteFile"
          @uploadSuccess="handlerUploadSuccess"
        />
        <v-upload
          label="Click to upload"
          @uploadSuccess="handlerUploadSuccess" /> -->
      </div>
    </section>
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import FileContainer from '@/views/components/file-container'
import businessPremiumForm from '@/views/components/business-premium-from'

import { addManualQuote, addManualPolicy, editManualQuote, editManualPolicy } from '@/api/ticket'
import {
  addReferralRequestManualPolicy
} from '@/api/request'
import {
  getManualPolicyDetail
} from '@/api/policy'

export default {
  name: 'AddQuoteContainer',
  components: {
    FileContainer,
    businessPremiumForm
  },
  mixins: [MixinOptions],
  props: {
    type: {
      type: Number,
      default: 1
    },
    quoteId: [String, Number],
    relation: {
      type: Object,
      default: () => ({})
    },
    orderId: {
      type: [String, Number],
      default: ''
    },
    customerId: {
      type: [String, Number],
      default: ''
    },
    isReferralRequest: {
      type: Boolean,
      default: false
    },
    referralRequestId: {
      type: Number,
      default: 0
    },
    // 標記是 business ticket 裡 未完成 payment 得體 quote
    quoteOrderId: {
      type: [String, Number],
      default: 0
    }
  },
  data() {
    return {
      motorsType: 1501,
      benefitsType: 1201,
      formData: {
        company_id: '',
        quotation_number: '',
        eff_date: '',
        date: [],
        pcy_no: '',
        files: [],
        remark: '',
        //
        insurance_type: '',
        isrd_nm: '',
        contact_nm: '',
        contact_phone: '',
        email: ''
      },
      isEdit: false,
      premiumForm: {},
      policyDetail: {}
    }
  },
  computed:{
    // isIndustry() {
    //   return true
    // },
    manualList(){
      console.log('relation',this.relation)
      let manulLength = this.globalOptions.manual_quote_company.length
      return this.globalOptions.manual_quote_company.slice(1,manulLength)
    },
    typeOptions() {
      return [
        ...this.ticketOptions.insureTypeOptions
        // {
        //   label: 'By Insurance Type',
        //   options: this.ticketOptions.insureTypeOptions
        // },
        // {
        //   label: 'By Industry',
        //   options: this.industryTypeOptions
        // }
      ]
    },
  },
  // watch: {
  //   relation: {
  //     immediate: {
  //       immediate: true
  //     }
  //   }
  // },
  watch: {
    quoteOrderId: {
      immediate: true,
      handler(val) {
        if(val) {
          this.network().getManualPolicyDetail()
        }
      }
    },
    policyDetail: {
      immediate: true,
      deep: true,
      handler(val) {
        if(val && JSON.stringify(val) != '{}') {
          this.updateEditData(val, 'payment')
        }
      }
    }
  },
  methods: {
    initData() {
      this.formData = Object.assign(this.formData, {
        company_id: '',
        quotation_number: '',
        eff_date: '',
        date: [],
        pcy_no: '',
        files: [],
        remark: ''
      })
      this.isEdit = false
    },
    handlerCancel() {
      this.initData()
      this.$emit('cancel')
    },
    handlerUploadSuccess({ data, result, otherData }) {
      const { index = '' } = otherData
      if(!this.formData.files) {
        this.formData.files = []
      }
      if(index === '') {
        this.formData.files.push(data)
      } else {
        // this.formData.files[index] = data
        this.$set(this.formData.files, index, data)
      }
    },
    initPolicyData(data) {
      const { isrd_nm, name, phone, email, insurance_type } = data

      let params = {
        isrd_nm,
        contact_nm: name,
        contact_phone: phone,
        email,
        insurance_type
      }
      if(insurance_type >= 1500 && insurance_type < 1600) {
        params.insurance_type = 1500
        this.motorsType = insurance_type
      }
      if(insurance_type >= 1200 && insurance_type < 1300) {
        params.insurance_type = 1200
        this.benefitsType = insurance_type
      }

      this.formData = {
        ...this.formData,
        ...params
      }
    },
    updateEditData(data, origin) {
      this.initData()
      let {
        company_id,
        quotation_number,
        files = [],
        pcy_no,
        date = [],
        remark,
        insurance_type,
        isrd_nm,
        contact_nm,
        contact_phone,
        email,
        pcy_cmnt_dt,
        pcy_expry_dt } = data

      if(insurance_type >= 1500 && insurance_type < 1600) {
        this.motorsType = insurance_type
        insurance_type = 1500
      }
      if(insurance_type >= 1200 && insurance_type < 1300) {
        this.benefitsType = insurance_type
        insurance_type = 1200
      }

      let params = {
        company_id,
        quotation_number,
        files,
        pcy_no,
        date,
        remark,
        insurance_type,
        isrd_nm,
        contact_nm,
        contact_phone,
        email
      }

      if(origin == 'payment') {
        params.date = [
          pcy_cmnt_dt,
          pcy_expry_dt
        ]
      }

      this.formData = Object.assign(this.formData, params)

      this.isEdit = true
    },
    handlerDeleteFile(otherData) {
      const { index } = otherData
      this.formData.files.splice(index, 1)
    },
    handlerSaveQuote() {
      if(this.isEdit) {
        this.network().editManualQuote()
      } else {
        this.network().addManualQuote()
      }

    },
    handlerGetPremium() {
      this.$refs['premium'].submitForm()
    },
    handlerCreatePolicy() {
      if(this.isEdit) {
        this.network().editManualPolicy()
      } else {
        if(this.isReferralRequest) {
          this.network().addReferralRequestManualPolicy()
          return
        }
        this.network().addManualPolicy()
      }

    },
    handler() {
      return {
        getPolicyParams: () => {
          const {
            company_id, pcy_no, date, files, remark,
            insurance_type, isrd_nm, contact_nm, contact_phone, email
          } = this.formData
          let type = insurance_type
          if(type == 1500) {
            type = this.motorsType
          }
          if(type == 1200) {
            type = this.benefitsType
          }

          if(this.isReferralRequest) {
            return {
              referral_request_id: this.referralRequestId,
              company_id,
              pcy_no,
              pcy_cmnt_dt: date[0],
              pcy_expry_dt: date[1],
              insurance_type: type,
              isrd_nm,
              contact_nm,
              contact_phone,
              email,
              remark,
              ...this.premiumForm
            }
          }

          return {
            manual_quote_id: this.quoteId,
            company_id,
            pcy_no,
            pcy_cmnt_dt: date[0],
            pcy_expry_dt: date[1],
            pcy_file: files,
            remark,
            insurance_type: type,
            isrd_nm,
            contact_nm,
            contact_phone,
            email,
            ...this.premiumForm
          }
        }
      }
    },
    getSubmitPremium(data){
      Object.assign(this.quoteList[0]||{}, data)
    },
    submitPremium(form,data){
      // this.subForm[form] = true
      // Object.assign(this.quoteList[0]||{}, data)
      this.premiumForm = data
      this.handlerCreatePolicy()
    },
    network() {
      return {
        addManualQuote: async () => {
          const { company_id, quotation_number, files } = this.formData
          const { data } = await addManualQuote({
            company_id,
            quotation_number,
            manual_quote_id: this.quoteId,
            quote_file: files
          })
          this.initData()
          this.$emit('save')
        },
        addManualPolicy: async () => {
          const params = this.handler().getPolicyParams()
          params.code = params.promo_code
          delete params.promo_code
          const { data } = await addManualPolicy({
            ...params
          })
          this.initData()
          // this.$emit('save')
          this.$emit('create-success', data)
        },

        addReferralRequestManualPolicy: async () => {
          const params = this.handler().getPolicyParams()
          const { data } = await addReferralRequestManualPolicy(params)
          this.initData()
          this.$emit('create-success', data)
        },

        editManualQuote: async () => {
          const { company_id, quotation_number, files } = this.formData
          const { data } = await editManualQuote({
            company_id,
            quotation_number,
            manual_quote_id: this.quoteId,
            quote_file: files
          })
          this.initData()
          this.$emit('save')
        },
        editManualPolicy: async () => {
          // const { company_id, pcy_no, date, files, remark } = this.formData
          const params = this.handler().getPolicyParams()
          params.code = params.promo_code
          delete params.promo_code
          const { data } = await editManualPolicy({
            // manual_quote_id: this.quoteId,
            // company_id,
            // pcy_no,
            // pcy_cmnt_dt: date[0],
            // pcy_expry_dt: date[1],
            // pcy_file: files,
            // remark
            ...params,
            order_id: this.quoteOrderId? this.quoteOrderId: this.orderId
          })
          this.initData()
          if(this.quoteOrderId) {
            this.$emit('create-success', {
              id: this.quoteOrderId
            })
          }
          else {
            this.$emit('save')
          }

        },
        getManualPolicyDetail: async () => {
          const { data } = await getManualPolicyDetail({
            order_id: this.quoteOrderId,
          })
          this.policyDetail = data
        },
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.add-quote-container {
    position: relative;
    padding: 15px;
    .abs-top-right {
        top: 15px;
        right: 15px;
    }
    .form-container {
        width: 820px;
    }
}
</style>
